import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["value"]

import IoInputWrapper from '@/components/form/InputWrapper.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Select',
  props: /*#__PURE__*/_mergeModels({
    label: { default: undefined },
    options: { default: () => [] }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const modelValue = _useModel<unknown>(__props, "modelValue");



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IoInputWrapper, { label: _ctx.label }, {
    default: _withCtx(({ inputId }) => [
      _withDirectives(_createElementVNode("select", {
        id: inputId,
        style: {"width":"100%"},
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, optionInx) => {
          return (_openBlock(), _createElementBlock("option", {
            key: `${inputId}-${optionInx}`,
            value: option.value
          }, _toDisplayString(option.label), 9, _hoisted_2))
        }), 128))
      ], 8, _hoisted_1), [
        [_vModelSelect, modelValue.value]
      ])
    ]),
    _: 1
  }, 8, ["label"]))
}
}

})